module.exports = __webpack_public_path__ + "media/images/athletes/497-f1398bc51f248e7a1871c889d470cd67.png";